import { render } from "./aboutView.vue?vue&type=template&id=7653a1c4"
import script from "./aboutView.vue?vue&type=script&lang=js"
export * from "./aboutView.vue?vue&type=script&lang=js"

import "./aboutView.vue?vue&type=style&index=0&id=7653a1c4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__